<template>
  <div class="module-title" :style="{ marginBottom: large ? '50px' : '30px' }">

    <div class="module-title-BJI line-container-left">
      <div>
        <span class="line-1"></span>
      </div>
      <div>
        <span class="line-2"></span>
      </div>
      <div>
        <span class="line-3"></span>
      </div>
    </div>

    <span class="module-title-info">{{ title }}</span>

    <div class="module-title-BJI line-container-right">
      <div>
        <span class="line-1"></span>
      </div>
      <div>
        <span class="line-2"></span>
      </div>
      <div>
        <span class="line-3"></span>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        title: ''
      }
    },
    props: {
      id: {
        type: Number,
        default: -1
      },
      large: {
        type: Boolean,
        default: false
      },
      moduleFlag: {
        type: String,
        default: ''
      }
    },
    created() {
      const moduleList = this._modules

      for (let i = 0; i < moduleList.length; i++) {
        const item = moduleList[i]
        if (`${item.router}_${item.moduleIndex}` === this.moduleFlag) {
          this.title = item.showText || item.moduleName
          break
        }
      }
    }
  }
</script>